export enum bgColorOption {
  babyBlue = 'babyBlue',
  bayBlue = 'bayBlue',
  buttermilk = 'buttermilk',
  celery = 'celery',
  cloud = 'cloud',
  gulfStream = 'gulfStream',
  hummingBird = 'hummingBird',
  lightBlue = 'lightBlue',
  lightGray = 'lightGray',
  lightGreen = 'lightGreen',
  paleYellow = 'paleYellow',
  purple = 'purple',
  registryLightBlue = 'registryLightBlue',
  rose = 'rose',
  softPink = 'softPink',
  strikemasterPurplish = 'strikemasterPurplish',
  white = 'white',
  jewelBlue = 'jewelBlue',
}
